import React, {useEffect} from 'react';
import {observer} from 'mobx-react-lite';
import {Flex} from 'antd';

import ImgInventory2 from '@/shared/pictures/inventory_2.png';
import ImgInventory3 from '@/shared/pictures/welcome.png';
import ImgInventory4 from '@/shared/pictures/ovi_flex_100.png';
import ImgInventory5 from '@/shared/pictures/empty_net.png';

import {useStore} from '@/app/providers/StoreProvider';
import {MyTimer} from '@/shared/ui/MyTimer';
import {Loading} from '@/shared/ui/Loading';
import {IUpgrade} from "@/entities/inventory/types";


export const InventoryPage = observer(() => {

    const {userStore, inventoryStore, modalStore} = useStore();

    const boughtItems = userStore.gameInfo.user.boughtItems;
    const {inventoryItems, loading} = inventoryStore;

    useEffect(() => {
        const fetchInventory = async () => {
            await inventoryStore.getInventory();
        }
        if (!inventoryItems) {
            fetchInventory();
        }
    }, []);


    const openBuyModal = (id: string,level:number, item: IUpgrade) => {
        modalStore.open("buyItem",{
            id,
            level:level,
            title: item.name,
            description: item.description,
            imgUrl: item.imgUrl
        });
    }
    if (loading) return <Loading/>

    return (

        <div className="inventory-page">
            <div className="container">

                <h1 className='inventory-page_title'>Инвентарь</h1>

                <div className='inventory-items'>

                        {Object.entries(inventoryItems).map(([id, inventoryItem]) => {
                            const boughtItem = boughtItems[id];

                            const level = boughtItem?.level ?? 1;
                            const isBought = boughtItem?.bought ?? false;
                            const nextRebuyAt = boughtItem?.nextRebuyAt ?? null;
                            const isActiveConsumable = !!inventoryItem.hitsDuration && !!inventoryStore.activeConsumables[id];

                            const currentUpgrade = inventoryItem.upgrades[level];
                            const nextUpgrade: IUpgrade | undefined = inventoryItem.upgrades[level + 1];

                            if (!currentUpgrade) return null;
                            return (
                                <div
                                    className={`inventory-item ${isBought || isActiveConsumable ? 'inventory-item-active' : ''}`}>
                                    <Flex justify={'space-between'} gap={10}>
                                        <Flex justify={'space-between'} style={{width:'100%'}}>
                                            <Flex vertical gap={5} >
                                                <h2 className='inventory-item_title'>{currentUpgrade.name}</h2>
                                                <p className='inventory-item_text'>{currentUpgrade.description}</p>
                                            </Flex>
                                            <img className='inventory-item_img' src={currentUpgrade.imgUrl} alt=""/>
                                        </Flex>
                                        {
                                            isBought
                                                ? nextUpgrade
                                                    ? <button type='button' className='inventory-item_button' onClick={() => {openBuyModal(id, level, nextUpgrade ?? currentUpgrade)}}>Улучшить</button>
                                                    : null
                                                : nextRebuyAt
                                                    ? <div className='inventory-item_button'>
                                                        <MyTimer date={nextRebuyAt} onFinish={() => false}/>
                                                    </div>
                                                    : !isActiveConsumable &&
                                                    <button type='button' className='inventory-item_button' onClick={() => {openBuyModal(id, level, nextUpgrade ?? currentUpgrade)}}>Купить</button>
                                        }

                                    </Flex>
                                </div>
                            );
                        })}

                </div>

            </div>

        </div>
    );
});
